import React from "react";

import {

    FaChartLine,

    FaInfoCircle,

    FaPowerOff

} from "react-icons/fa";


import InstallationTable from "./InstallationTable";


class InstallationCard extends React.Component {


    render(){


         //console.log(
    //"installationCard installations:",
    //this.props.installations);


        const {

            //installations,

            onDetails,

            onDeactivate


        } = this.props;


            /* console.log(
              "InstallationTable props:",
               this.props.installations
            );*/

            const installations =
            (this.props.installations || []).filter(
                item => item.status === "ACTIVE"
            );

           /* console.log(
              "Active installations:",
               installations
            );*/



        return (


            <div className="idms-card">


                <div className="card-header">


                    <div>


                        <h2 className="card-title">

                            Active MT5 Installations

                        </h2>


                        <p className="card-subtitle">

                            Your connected trading terminals

                        </p>


                    </div>


                </div>





                <div className="installation-grid"  className="engine-status-box">



                <InstallationTable


                    installations={installations}

                    onDetails={this.props.onDetails}

                    onDeactivate={this.props.onDeactivate}

                    onRefresh={this.props.onRefresh}

                    showDetailsModal = {this.props.showDetailsModal}

                    selectedInstallation={this.props.selectedInstallation}


                    />

                </div>


            </div>


        );


    }


}



export default InstallationCard;